import React from "react";

interface Event {
   title: string;
  description: string;
  dateTime: string;
  action: string;
}

interface Props {
  events: Event[];
}

const UpcomingEvents: React.FC<{ events: Event[] }> = ({ events }) => {
  if (events.length === 0) return <p  className="no-events">No upcoming events</p>;

  return (
    <div className="event-container">
      <h3 className="title-text">Upcoming Events</h3>
      <ul className="events-list">
        {events.map((event, idx) => (
          <li key={idx} className="event-item">
            <strong className="subtitle-text">{event.title}</strong> <br />
            <span className="event-description">{event.description}</span> <br />
            <span className="event-date"><i className="fa-regular fa-clock colorOrange" ></i> {event.dateTime}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default UpcomingEvents;